import PropTypes from "prop-types";

export default function SectionEyebrow({ children, align = "left", dark = false }) {
  return (
    <div
      className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}
    >
      <span className="h-px w-6 wt-bg-gold" aria-hidden="true" />
      <span
        className="text-[11px] font-semibold tracking-[0.18em] uppercase"
        style={{ color: dark ? "rgba(250,247,240,0.85)" : "var(--wt-primary)" }}
      >
        {children}
      </span>
    </div>
  );
}

SectionEyebrow.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(["left", "center"]),
  dark: PropTypes.bool,
};
